import { useState, useEffect } from 'react'
import axios from 'axios'
import { Modal, Tag } from 'antd'

const AlmamaterVisitMemberDetail = (props) => {
  const merchantOid = localStorage.getItem('merchant_oid')
  const [memberDetail, setMemberDetail] = useState({})

  useEffect(() => {
    axios.post('/p/almamater_visit/member/detail/get', {
      merchant_oid: merchantOid,
      member_oid: props.data.oid
    })
      .then(function (response) {
        if (response.errcode === 0) {
          setMemberDetail(response.data)
        }
      })
      .catch(function (error) {
        console.error('请求失败，错误信息为：', error)
      })
  }, [merchantOid, props.data])

  const handleCancel = () => {
    props.isCancel()
  }

  return (
    <Modal 
      title="成员行程详情"
      destroyOnClose={true}
      width='700px'
      open={props.isOpen}
      onCancel={handleCancel}
      footer={false}>
      
      <div className='public-datail-container'>
        <div className='public-datail-item'>
          <div className='public-datail-label'>所属分类</div>
          <div className='public-datail-content'>{memberDetail.category}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>姓名</div>
          <div className='public-datail-content'>{memberDetail.name}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>身份证号</div>
          <div className='public-datail-content'>{memberDetail.id_number}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>学号</div>
          <div className='public-datail-content'>{memberDetail.student_id}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>手机号</div>
          <div className='public-datail-content'>{memberDetail.phone}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>QQ号</div>
          <div className='public-datail-content'>{memberDetail.qq_number}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>学院</div>
          <div className='public-datail-content'>{memberDetail.college}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>专业</div>
          <div className='public-datail-content'>{memberDetail.major}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>团队名称</div>
          <div className='public-datail-content'>{memberDetail.team}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>团队角色</div>
          <div className='public-datail-content'>{memberDetail.role}</div>
        </div>
        <div className='public-datail-item'>
          <div className='public-datail-label'>回访学校</div>
          <div className='public-datail-content'>
            {
              memberDetail.itineraries && memberDetail.itineraries.length > 0
                ? memberDetail.itineraries.map(item => (
                    <Tag
                      key={item.oid}
                      color={item.is_visit === 1 ? 'green' : 'default'}
                      style={{ marginBottom: 6 }}
                    >
                      {item.name}
                      {item.is_visit === 1 ? '（已回访）' : '（未回访）'}
                    </Tag>
                  ))
                : <span style={{ color: '#999' }}>暂无回访学校</span>
            }
          </div>
        </div>
      </div>
    </Modal>
  )
}

export default AlmamaterVisitMemberDetail
